import { createContext } from 'react';

/**
 * @typedef {Object} NotificationOptions
 * @property {string} message
 * @property {string} title
 * @property {string} [button]
 * @property {() => void} [buttonAction]
 * @property {boolean} [hideCloseButton]
 * @property {boolean} [hideHelpButton]
 * @property {boolean} [hasCancelButton]
 * @property {Object} [customMessageStyle]
 */

/**
 * @typedef {Object} NotificationContextValue
 * @property {NotificationOptions} notification
 * @property {(options: NotificationOptions) => void} addNotification
 * @property {() => void} clearNotification
 */

/** @type {React.Context<NotificationContextValue>} */
var NotificationContext = createContext({
  notification: null,
  addNotification: function addNotification() {},
  clearNotification: function clearNotification() {}
});
export default NotificationContext;